import { useEffect, useState } from 'react';
import { HeartPulse, Loader2 } from 'lucide-react';
import { useApi } from '../api/client';

export default function Health() {
  const apiFetch = useApi();
  const [data, setData] = useState<unknown>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiFetch('/health')
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(setData)
      .catch((e) => setError(String(e)));
  }, [apiFetch]);

  return (
    <div className="rounded-2xl border border-brand-sage/30 bg-white p-6 shadow-sm">
      <div className="mb-4 flex items-center gap-2">
        <HeartPulse className="h-5 w-5 text-brand-lime-600" />
        <h2 className="font-display text-2xl font-black text-brand-forest">
          Health
        </h2>
      </div>
      <p className="mb-4 text-sm text-brand-sage">
        Round-trip: SPA → API Gateway (JWT) → Lambda → RDS via IAM auth.
      </p>
      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </div>
      )}
      {!data && !error && (
        <div className="flex items-center gap-2 text-brand-sage">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="text-sm">Pinging…</span>
        </div>
      )}
      {data ? (
        <pre className="overflow-x-auto rounded-lg bg-brand-forest-900/95 p-4 text-xs leading-relaxed text-brand-sky-100">
          {JSON.stringify(data, null, 2)}
        </pre>
      ) : null}
    </div>
  );
}